class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    
    // Listen for variant changes to update discounted status
    document.addEventListener('variant:change', this.onVariantChange.bind(this));
  }
  
  // Called when a variant changes
  onVariantChange(event) {
    if (!event.detail.variant) return;
    
    // Get the selected variant
    const variant = event.detail.variant;
    
    // Update the discounted attribute based on the selected variant
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      this.setAttribute('data-discounted', 'true');
    } else {
      this.removeAttribute('data-discounted');
    }
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    try {
      // Get variant ID and quantity
      const formData = new FormData(this.form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity') || 1);

      // Get product ID from the form or page
      const productId = document.querySelector('meta[property="og:product:id"]')?.content || 
                         document.querySelector('[data-product-id]')?.dataset.productId || 
                         this.form.dataset.productId;
      
      console.log('Debug - Product ID:', productId);
      
      // Define special products with their own limits regardless of discount status
      const specialProducts = ['8589806338353', '8589806272817'];
      
      // Retrieve or look up the product ID from the variant if needed
      let isSpecialProduct = false;
      
      // First check if the productId is one of our special products
      if (productId && specialProducts.includes(productId.toString())) {
        console.log('Debug - Identified as special product by product ID');
        isSpecialProduct = true;
      }
      
      // If not identified by product ID, we need to check if this variant belongs to special products
      if (!isSpecialProduct && variantId) {
        // Check if hidden input has data about this variant's product
        const variantInput = this.form.querySelector(`input[value="${variantId}"]`);
        if (variantInput && variantInput.dataset.productId && specialProducts.includes(variantInput.dataset.productId)) {
          console.log('Debug - Identified as special product by variant input');
          isSpecialProduct = true;
        }
        
        // If we still don't know, check the cart items for reference
        if (!isSpecialProduct) {
          // Check current cart to see if any special products are already there
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Check all cart items to see if variant belongs to a special product
          for (const item of cart.items) {
            if (item.variant_id == variantId && specialProducts.includes(item.product_id.toString())) {
              console.log('Debug - Identified as special product by cart check');
              isSpecialProduct = true;
              break;
            }
          }
        }
      }
      
      // Check current cart to see what's already in it
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Apply appropriate limit based on product type
      if (isSpecialProduct) {
        console.log('Debug - Applying 30 item limit for special product');
        // For special products, apply 30 item limit
        const maxLimit = 30;
        
        // Find if this product is already in the cart by variant ID
        const existingItem = cart.items.find(item => item.variant_id == variantId);
        const existingQuantity = existingItem ? existingItem.quantity : 0;
        const totalQuantity = existingQuantity + quantity;
        
        // Check if adding would exceed the limit
        if (totalQuantity > maxLimit) {
          // Translate error message based on URL path
          let errorMessage = '';
          if (window.location.pathname.includes('/tr')) {
            errorMessage = `Bu üründen en fazla ${maxLimit} adet satın alabilirsiniz. Sepetinizde zaten ${existingQuantity} adet var.`;
          } else if (window.location.pathname.includes('/en')) {
            errorMessage = `You can buy a maximum of ${maxLimit} units of this product. You already have ${existingQuantity} in your cart.`;
          } else if (window.location.pathname.includes('/ru')) {
            errorMessage = `Вы можете купить максимум ${maxLimit} единиц этого продукта. У вас уже есть ${existingQuantity} в корзине.`;
          } else {
            errorMessage = `Bu məhsuldan maksimum ${maxLimit} ədəd ala bilərsiniz. Səbətinizdə artıq ${existingQuantity} ədəd var.`;
          }
          
          alert(errorMessage);
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          return; // Stop the submission
        }
      }
      else {
        console.log('Debug - Checking if product is kg-based or discounted');
        
        // Check if product is kg-based
        const isKgProduct = await this.isKgProduct(variantId);
        console.log('Debug - Is product kg-based:', isKgProduct);
        
        // Check if product is discounted
        const isDiscounted = await this.isProductDiscounted(variantId);
        console.log('Debug - Is product discounted:', isDiscounted);
        
        // Apply limit for both kg products and discounted products
        if (isKgProduct || isDiscounted) {
          // Find if this product is already in the cart
          const existingItem = cart.items.find(item => item.variant_id == variantId);
          const existingQuantity = existingItem ? existingItem.quantity : 0;
          const totalQuantity = existingQuantity + quantity;
          
          // Check if adding would exceed the limit of 10
          if (totalQuantity > 10) {
            let errorMessage = '';
                        if (window.location.pathname.includes('/tr')) {
              if (isKgProduct && isDiscounted) {
                errorMessage = `Ağırlık bazlı (KG/GR) ve indirimli ürünlerden en fazla 10 adet satın alabilirsiniz. Sepetinizde zaten ${existingQuantity} adet var.`;
              } else if (isKgProduct) {
                errorMessage = `Ağırlık bazlı (KG/GR) ürünlerden en fazla 10 adet satın alabilirsiniz. Sepetinizde zaten ${existingQuantity} adet var.`;
              } else {
                errorMessage = `İndirimli ürünlerden en fazla 10 adet satın alabilirsiniz. Sepetinizde zaten ${existingQuantity} adet var.`;
              }
                        } else if (window.location.pathname.includes('/en')) {
              if (isKgProduct && isDiscounted) {
                errorMessage = `You can buy a maximum of 10 units of weight-based (KG/GR) and discounted products. You already have ${existingQuantity} in your cart.`;
              } else if (isKgProduct) {
                errorMessage = `You can buy a maximum of 10 units of weight-based (KG/GR) products. You already have ${existingQuantity} in your cart.`;
              } else {
                errorMessage = `You can buy a maximum of 10 units of discounted products. You already have ${existingQuantity} in your cart.`;
              }
                        } else if (window.location.pathname.includes('/ru')) {
              if (isKgProduct && isDiscounted) {
                errorMessage = `Вы можете купить максимум 10 единиц весовых товаров (КГ/ГР) и товаров со скидкой. У вас уже есть ${existingQuantity} в корзине.`;
              } else if (isKgProduct) {
                errorMessage = `Вы можете купить максимум 10 единиц весовых товаров (КГ/ГР). У вас уже есть ${existingQuantity} в корзине.`;
              } else {
                errorMessage = `Вы можете купить максимум 10 единиц товаров со скидкой. У вас уже есть ${existingQuantity} в корзине.`;
              }
                        } else {
              if (isKgProduct && isDiscounted) {
                errorMessage = `Çəkili (KQ/QR) və endirimli məhsullardan maksimum 10 ədəd ala bilərsiniz. Səbətinizdə artıq ${existingQuantity} ədəd var.`;
              } else if (isKgProduct) {
                errorMessage = `Çəkili (KQ/QR) məhsullardan maksimum 10 ədəd ala bilərsiniz. Səbətinizdə artıq ${existingQuantity} ədəd var.`;
              } else {
                errorMessage = `Endirimli məhsullardan maksimum 10 ədəd ala bilərsiniz. Səbətinizdə artıq ${existingQuantity} ədəd var.`;
              }
            }
            
            alert(errorMessage);
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('disabled');
            return; // Stop the submission
          }
        }
      }

      // Proceed with normal form submission
      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body });
      const parsedState = await response.json();
      this.cartNotification.renderContents(parsedState);
    }
    catch (e) {
      console.error(e);
    }
    finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    }
  }

  // Check if a product is discounted
  async isProductDiscounted(variantId) {
    // Special products with 30 item limit regardless of discount status
    const specialProductIds = ['8589806338353', '8589806272817'];
    
    // Get product ID from the form or page
    const productId = document.querySelector('meta[property="og:product:id"]')?.content || 
                      document.querySelector('[data-product-id]')?.dataset.productId || 
                      this.form.dataset.productId;
    
    // If this is one of our special products by productId, don't consider it "discounted" for limit purposes
    if (productId && specialProductIds.includes(productId.toString())) {
      return false;
    }
    
    // Check if hidden input has data about this variant's product
    const variantInput = this.form.querySelector(`input[value="${variantId}"]`);
    if (variantInput && variantInput.dataset.productId && specialProductIds.includes(variantInput.dataset.productId)) {
      return false;
    }
    
    // Try to find this variant in cart as well
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check if this variant belongs to a special product already in cart
      for (const item of cart.items) {
        if (item.variant_id == variantId && specialProductIds.includes(item.product_id.toString())) {
          return false;
        }
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
    
    // First check if there's an element with data-variant-id and data-discounted attributes
    const productElement = document.querySelector(`[data-variant-id="${variantId}"][data-discounted="true"]`);
    if (productElement) {
      // Extra check for special products
      if (productElement.dataset.productId && specialProductIds.includes(productElement.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check if the product form itself has a discounted attribute
    if (this.hasAttribute('data-discounted') && this.getAttribute('data-discounted') === 'true') {
      // Extra check for special products
      if (this.dataset.productId && specialProductIds.includes(this.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check if there's a data-discounted input field
    const discountedInput = this.form.querySelector('input[data-discounted="true"]');
    if (discountedInput) {
      // Extra check for special products
      if (discountedInput.dataset.productId && specialProductIds.includes(discountedInput.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check the selected variant directly
    const currentVariantData = this.form.querySelector(`input[name="id"][value="${variantId}"]`);
    if (currentVariantData && currentVariantData.dataset.variantCompareAtPrice && 
        parseFloat(currentVariantData.dataset.variantCompareAtPrice) > parseFloat(currentVariantData.dataset.variantPrice)) {
      // Extra check for special products
      if (currentVariantData.dataset.productId && specialProductIds.includes(currentVariantData.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // If we still couldn't determine, check if the variant has a compare_at_price
    try {
      const response = await fetch(`/products.json?variant=${variantId}`);
      if (response.ok) {
        const data = await response.json();
        // Find the variant in the products returned
        for (const product of data.products) {
          // If product is one of our special products, don't consider it discounted
          if (specialProductIds.includes(product.id.toString())) {
            return false;
          }
          
          const variant = product.variants.find(v => v.id == variantId);
          if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
            return true;
          }
        }
      }
    } catch (error) {
      console.error('Error checking product discount status:', error);
    }
    
    return false;
  }

  // Check if a product is kg-based
  async isKgProduct(variantId) {
    // Special products with 30 item limit regardless of kg status
    const specialProductIds = ['8589806338353', '8589806272817'];
    
    // Get product ID from the form or page
    const productId = document.querySelector('meta[property="og:product:id"]')?.content || 
                      document.querySelector('[data-product-id]')?.dataset.productId || 
                      this.form.dataset.productId;
    
    // If this is one of our special products by productId, don't consider it "kg-based" for limit purposes
    if (productId && specialProductIds.includes(productId.toString())) {
      return false;
    }
    
    // Check if hidden input has data about this variant's product
    const variantInput = this.form.querySelector(`input[value="${variantId}"]`);
    if (variantInput && variantInput.dataset.productId && specialProductIds.includes(variantInput.dataset.productId)) {
      return false;
    }
    
    // Try to find this variant in cart as well
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check if this variant belongs to a special product already in cart
      for (const item of cart.items) {
        if (item.variant_id == variantId && specialProductIds.includes(item.product_id.toString())) {
          return false;
        }
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
    
    // First check if there's an element with data-variant-id and data-kg-based attributes
    const productElement = document.querySelector(`[data-variant-id="${variantId}"][data-kg-based="true"]`);
    if (productElement) {
      // Extra check for special products
      if (productElement.dataset.productId && specialProductIds.includes(productElement.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check if the product form itself has a kg-based attribute
    if (this.hasAttribute('data-kg-based') && this.getAttribute('data-kg-based') === 'true') {
      // Extra check for special products
      if (this.dataset.productId && specialProductIds.includes(this.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check if there's a data-kg-based input field
    const kgBasedInput = this.form.querySelector('input[data-kg-based="true"]');
    if (kgBasedInput) {
      // Extra check for special products
      if (kgBasedInput.dataset.productId && specialProductIds.includes(kgBasedInput.dataset.productId)) {
        return false;
      }
      return true;
    }
    
    // Check if product uses kg template suffix
    try {
      const response = await fetch(`/products.json?variant=${variantId}`);
      if (response.ok) {
        const data = await response.json();
        // Find the variant in the products returned
        for (const product of data.products) {
          // If product is one of our special products, don't consider it kg-based
          if (specialProductIds.includes(product.id.toString())) {
            return false;
          }
          
          const variant = product.variants.find(v => v.id == variantId);
          if (variant) {
            // Check if product title contains kg
            if (product.title && (product.title.toLowerCase().includes('kg') || 
                                 product.title.toLowerCase().includes('kilo') ||
                                 product.title.toLowerCase().includes('kilogram'))) {
              return true;
            }
            
            // Check if product handle contains kg (which would indicate kg template suffix)
            if (product.handle && product.handle.includes('kg')) {
              return true;
            }
            
            // Check if product tags contain KG or GR
            if (product.tags && Array.isArray(product.tags)) {
              for (const tag of product.tags) {
                if (tag && (tag.toUpperCase().includes('KG') || tag.toUpperCase().includes('GR'))) {
                  return true;
                }
              }
            }
          }
        }
      }
    } catch (error) {
      console.error('Error checking product kg-based status:', error);
    }
    
    // Additional check: if we're on a page with .kg template
    if (window.location.pathname.includes('.kg') || 
        document.body.classList.contains('template-product-kg')) {
      return true;
    }
    
    return false;
  }
}

customElements.define('product-form', ProductForm);
